/*
Sohel 01/02/2023 2789725780 Added search Form
Sohel 01/02/2023 2789725780 Added integrated Save API
dilip 01/09/2023 2789725780 Added search data local storage
Suresh Peddavoora  01/11/2023 2789725780 Fixed Responsive issues for Textfields
manikanta  01/12/2023 2701315830,3075154998 implemented uppercase
manikanta  01/12/2023 2701315830,3075154998 removed uppercase
manikanta  01/13/2023 2701315830,3075154998 reportCode uppercase
Sohel 01/16/2023 2698964415 fixed Fields reset Issue
Ashraf 01/27/2023 2698964415 added new fields
Suresh Peddavoora  01/31/2023 2789725780 Fixed Responsive issues for Textfields
Sohel 01/08/2023 2701335619 implemented Usage Functionality
Rohini 02/09/2023 3075154998 added classnames and enhancements in the text feilds
Dilip 02/09/2023 2701335619 added creted for and creted by fields
Suresh Peddavoora  02/13/2023 2789725780 Fixed Textfields Variant
Rohini  02/28/2023 2789725780 fixed the text fields variants.
Rohini 02/28/2023 2789725780 changed the columns grid for screen enhancements.
//suresh peddavoora 03/03/2023 2789725780 Tables and fields alignments
T Santosh Kumar 15/03/2023 2789725780 Responsive UI Changes
Prakash 03/16/2023 2789725780 fixed ui bugs in responsive.
T Santosh Kumar 17/03/2023 2789725780 New UI Alignment Changes
Prakash 03/20/2023 2789725780 fixed alignments issues.
Akhila 06/08/2023 2789725780 title label placeholder name change
Akhila 06/08/2023 2789725780 rearrange the column and form fields
Akhila 06/12/2023 2789725780 added role access
Prakash 22/06/2023 2789725780 fixed alignments issues

*/
import React, {useContext, useEffect, useState} from 'react';
import {Form, Formik} from 'formik';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {Button, TextField, FormHelperText} from '@material-ui/core';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import {useSelector, useDispatch} from 'react-redux';
import {
  fetchCreatedByDropDownData,
  fetchCreatedForDropDownData,
  getAllReportCreatedForData,
} from '../../../../../redux/reducers/ReportMaster';
import {MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import SearchIMRTable from './SearchIMRGroupTable';
import * as Yup from 'yup';
import {createForOptions, createdByOptions} from '../../../../../util/CreatedByForOptions';

const exportManagerType = [{value: 'Data Export'}, {value: 'Header'}, {value: 'Footer'}];

const StatusOptions = [
  {key: 'Y', value: 'Draft'},
  {key: 'N', value: 'Completed'},
];

function SearchImportMRGroup({
  setValue,
  setDataManagerRecordGroupData = () => {},
  setEditExisting,
  exportRecordGroupAccess,
}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {createdForData, createdByData} = useSelector(
    ({reportMaster}) => reportMaster,
  );
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const dispatch = useDispatch();
  const validationSchema = Yup.object().shape({
    createdDate: Yup.date().typeError('Invalid date format').nullable(),
  });

  const categoryData = [
    {
      categoryCode: 'CO',
      categoryName: 'Core',
    },
  ];

  const promptOptions = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];

  const initialValues = {
    importMRGroupCode: '',
    importMRGroupDescripton: '',
    importMRGroupType: '',
    createdDate: null,
    isDraft: '',
    category: '',
    includeAudit: '',
    createdFor: '',
    createdBy: '',
  };

  const handleSubmit = (values) => {
    sessionStorage.setItem('EMRecordGroup', JSON.stringify(values));
    setSearchData(values);
    setSubmit(true);
  };
  useEffect(() => {
    dispatch(getAllReportCreatedForData());
    setEditExisting && setEditExisting(false);
  }, []);

  useEffect(() => {
    dispatch(fetchCreatedByDropDownData('exportrecordgroup'));
    dispatch(fetchCreatedForDropDownData('exportrecordgroup'));
  }, [dispatch]);

  const onClear = () => {
    const data = {
      importMRGroupCode: '',
      importMRGroupDescripton: '',
      importMRGroupType: '',
      createdDate: null,
      isDraft: '',
      category: '',
      includeAudit: '',
      createdFor: '',
      createdBy: '',
    };
    setSearchData(data);
    sessionStorage.removeItem('EMRecordGroup');
  };

  const EMRecordGroupSessionStorage = JSON.parse(sessionStorage.getItem('EMRecordGroup'));

  return (
    <div>
      <div className={` mb-0`}>
        <h2 className="search-title">Export Record Groups Search</h2>
        <Formik
          onSubmit={handleSubmit}
          initialValues={EMRecordGroupSessionStorage ? EMRecordGroupSessionStorage : initialValues}
          enableReinitialize
          validationSchema={validationSchema}
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleReset,
              handleBlur,
              setFieldValue,
              touched,
              errors,
            } = props;

            return (
              <div>
                <Form autoComplete="off">
                  <div className="form-row  standard-field-textfields new-standard-textfields">
                    <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3`}>
                      <TextField
                        margin="dense"
                        className={` ${classes.labelName}`}
                        variant="outlined"
                        placeholder={`Enter Export Record Group Name`}
                        label="Export Record Group Name"
                        name="importMRGroupCode"
                        value={values?.importMRGroupCode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.importMRGroupCode}
                      />
                    </div>
                    <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-4`}>
                      <TextField
                        margin="dense"
                        className={` ${classes.labelName}`}
                        variant="outlined"
                        placeholder="Enter Export Record Group Description"
                        label="Export Record Group Description"
                        name="importMRGroupDescripton"
                        value={values.importMRGroupDescripton}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="importMRGroupType"
                        id="importMRGroupType"
                        size="small"
                        value={values.importMRGroupType}
                        options={exportManagerType}
                        getOptionLabel={(option) => {
                          return option && option.value;
                        }}
                        onChange={(e, value) => {
                          setFieldValue('importMRGroupType', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field ">
                            <GuiTextField
                              className={` ${classes.labelName} group-type-field`}
                              {...params}
                              variant="outlined"
                              margin="dense"
                              label="Record Group Type"
                              placeholder="Select Record Group Type"
                            />
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 form-group">
                      <GuiAutoComplete
                        classes={{
                          popper: classes.popper,
                          option: classes.option,
                        }}
                        name="includeAudit"
                        id="includeAudit"
                        size="small"
                        options={promptOptions}
                        value={values.includeAudit}
                        getOptionLabel={(option) => {
                          return option && option?.value && option?.key ?
                            `${option?.key + ' - ' + option?.value}` :
                            option?.value;
                        }}
                        onChange={(e, value) => {
                          setFieldValue('includeAudit', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              className={` ${classes.labelName}`}
                              variant="outlined"
                              margin="dense"
                              // InputLabelProps={{ shrink: true }}
                              label="Include Audit"
                              placeholder="Select Include Audit"
                            />
                          </div>
                        )}
                      />
                    </div>
                    <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-3 form-group`}>
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="createdFor"
                        id="createdFor"
                        size="small"
                        value={values.createdFor}
                        options={createdForData}
                        getOptionLabel={(option) => {
                          return option && option?.userLoginName ? option?.userLoginName : '';
                        }}
                        renderOption={(option) => {
                          return createForOptions(option);
                        }}
                        onChange={(e, value) => {
                          setFieldValue('createdFor', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              className={` ${classes.labelName}`}
                              {...params}
                              variant="outlined"
                              margin="dense"
                              label="Created For"
                              placeholder="Select Created For"
                            />
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="createdBy"
                        id="createdBy"
                        size="small"
                        value={values.createdBy}
                        options={createdByData}
                        getOptionLabel={(option) => {
                          return option && option?.userLoginName ? option?.userLoginName : '';
                        }}
                        renderOption={(option) => {
                          return createdByOptions(option);
                        }}
                        onChange={(e, value) => {
                          setFieldValue('createdBy', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              className={` ${classes.labelName}`}
                              {...params}
                              variant="outlined"
                              margin="dense"
                              label="Created By"
                              placeholder="Select Created By"
                            />
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 form-group  start-enddate">
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          className={` ${classes.labelName}`}
                          format="MM/dd/yyyy"
                          placeholder="MM/DD/YYYY"
                          fullWidth
                          value={values.createdDate}
                          name="createdDate"
                          onBlur={handleBlur}
                          inputVariant="outlined"
                          helperText=""
                          label="Date Created"
                          error={Boolean(touched?.createdDate && errors?.createdDate)}
                          onChange={(val) => {
                            setFieldValue('createdDate', val);
                          }}
                          autoOk
                          margin="dense"
                        />
                      </MuiPickersUtilsProvider>
                      <FormHelperText variant="outlined">
                        {touched.createdDate && errors.createdDate ? errors.createdDate : ''}
                      </FormHelperText>
                    </div>
                    <div className={`col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-2`}>
                      <GuiAutoComplete
                        classes={{
                          popper: classes.popper,
                          option: classes.option,
                        }}
                        name="isDraft"
                        id="isDraft"
                        size="small"
                        options={StatusOptions}
                        required
                        value={values.isDraft}
                        getOptionLabel={(option) => {
                          return option && option?.value;
                        }}
                        onChange={(e, value) => {
                          setFieldValue('isDraft', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              className={` ${classes.labelName}`}
                              {...params}
                              variant="outlined"
                              margin="dense"
                              label="Status"
                              placeholder="Select Status"
                            />
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-sm-6 col-xs-6 col-md-4 col-lg-3 col-xl-2  form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                          popper: classes.popper,
                        }}
                        name="category"
                        id="category"
                        size="small"
                        value={values.category}
                        options={categoryData?.length > 0 ? categoryData : []}
                        getOptionDisabled={(option) => option.categoryCode === ''}
                        getOptionLabel={(option) => {
                          return option && option.categoryName ?
                            option.categoryCode === null ?
                              option.categoryName :
                              option.categoryCode + ' - ' + option.categoryName :
                            '';
                        }}
                        onChange={(e, value) => {
                          setFieldValue('category', value);
                        }}
                        placeholder="Select Category"
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              className={` ${classes.labelName}`}
                              {...params}
                              variant="outlined"
                              margin="dense"
                              name="category"
                              label="Category"
                              placeholder="Select Category"
                            />
                          </div>
                        )}
                      />
                    </div>
                    {/* <div className="col-xl-1">

                    </div> */}
                    <div className="col-md-12 col-lg-4 col-xl-12 form-group">
                      <div className=" d-flex justify-content-md-center justify-content-lg-start justify-content-xl-center ">
                        <Button
                          variant="outlined"
                          className={`mr-1 reset-btn`}
                          onClick={() => {
                            handleReset();
                            setSubmit(true);
                            onClear();
                          }}
                        >
                          Reset
                        </Button>
                        <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
                          Search
                        </Button>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            );
          }}
        </Formik>
        <SearchIMRTable
          setValue={setValue}
          searchData={searchData}
          submit={submit}
          setSubmit={setSubmit}
          setDataManagerRecordGroupData={setDataManagerRecordGroupData}
          exportRecordGroupAccess={exportRecordGroupAccess}
          setEditExisting={setEditExisting}
        />
      </div>
    </div>
  );
}

export default SearchImportMRGroup;
